import Axios from 'axios';
import URL from '../../Environment';
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import IMGPATHS from '../../ImgPaths';

const Personalloanads = () => {
    const { id } = useParams(); // รับ id จาก URL
    const [loanData, setLoanData] = useState([]);
    const [loadingLoan, setLoanLoading] = useState(true);
    const [errorLoan, setLoanError] = useState(null);
    const [recentNews, setRecentNews] = useState([]);
    const [loadingRecentNews, setRecentNewsLoading] = useState(true);
    const [errorRecentNews, setRecentNewsError] = useState(null);

    useEffect(() => {
        const fetchLoanData = async () => {
            try {
                setLoanLoading(true);
                // ถ้าไม่มี id ให้ดึงทั้งหมด
                const apiUrl = id 
                    ? `${URL}api/PersonalLoanAds/GetPersonalLoan?id=${id}`
                    : `${URL}api/PersonalLoanAds/GetPersonalLoan?id=all`;
                
                const response = await Axios.get(apiUrl);
                console.log('Loan Data:', response.data);
                setLoanData(response.data);
                setLoanLoading(false);
            } catch (error) {
                console.log('Error:', error);
                setLoanError(error);
                setLoanLoading(false);
            }
        };
        
        const fetchRecentNewsData = async () => {
            try {
                const response = await Axios.get(`${URL}api/PersonalLoanAds/GetPersonalLoanRecentNews`);
                console.log('Recent News:', response.data);
                setRecentNews(response.data);
                setRecentNewsLoading(false);
            } catch (error) {
                console.log('Error:', error);
                setRecentNewsError(error);
                setRecentNewsLoading(false);
            }
        };

        fetchLoanData();
        fetchRecentNewsData();

    }, [id]); // เพิ่ม id เป็น dependency เพื่อให้ดึงข้อมูลใหม่เมื่อ id เปลี่ยน

    const countNews = async (newsid) => {
        try {
            await Axios.post(`${URL}api/PersonalLoanAds/CountNews`, {
                id: newsid,
            });
        } catch (err) {
            console.log('Error counting news:', err);
        }
    };

    if (loadingLoan || loadingRecentNews) {
        return <div>Loading...</div>;
    }
    
    if (errorLoan) {
        return <div>Error: {errorLoan.message}</div>;
    }

    return (
        <div>
            <section className="breadcrumbs">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                            <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link> 
                            <i className="fa fa-angle-right" />&nbsp;
                            <Link to="/personalloanads" className="a-breadcrumbs">สินเชื่อ</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="recent-posts section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-9 col-sm-9 mb-sm-50">
                            <h2 className="title-section mt-0 mb-0">
                                <span>บริการด้านสินเชื่อ</span>
                            </h2>
                            <br/>
                            <div className="divider gray left mt-20 mb-25"></div>
                        </div>
    
                        <div className="col-md-9">
                            <div className="row cws-multi-col">
                                {loanData.length > 0 ? (
                                    loanData.map((loan) => (
                                        <div key={loan.id} className="col-xl-4 col-md-6">
                                            <article>
                                                <div className="post-img">
                                                    <Link 
                                                        to={`/PersonalLoanDetail/${loan.id}`}
                                                        onClick={() => countNews(loan.id)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img 
                                                            src={`${IMGPATHS}img/Loan/${loan.img}`} 
                                                            className="img-fluid" 
                                                            alt={loan.topic} 
                                                        />
                                                    </Link>
                                                </div>
                                                <h2 className="title">
                                                    <Link 
                                                        to={`/PersonalLoanDetail/${loan.id}`}
                                                        style={{fontSize:'22px'}}
                                                        onClick={() => countNews(loan.id)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {loan.topic}
                                                    </Link>
                                                </h2>
                                            </article>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center">
                                        <p>ไม่พบข้อมูล</p>
                                    </div>
                                )}
                            </div>
                        </div>
    
                        <div className="col-md-3 sidebar">
                            <aside className="widget-categories">
                                <h2 className="widget-title">
                                    <i className="color-4 flaticon-list65"></i>&nbsp;Category
                                </h2>
                                <ul>
                                    <li className="cat-item">
                                        <Link to="/PersonalLoanAds/1">
                                             เงินกู้ฉุกเฉิน{/*<span>&nbsp;&nbsp;2</span> */}
                                        </Link>
                                    </li>
                                    <li className="cat-item">
                                        <Link to="/PersonalLoanAds/2">
                                            เงินกู้สามัญ{/*<span>&nbsp;&nbsp;2</span>*/}
                                        </Link>
                                    </li>
                                    <li className="cat-item">
                                        <Link to="/PersonalLoanAds/3">
                                            เงินกู้พิเศษเพื่อยานพาหนะ{/*<span>&nbsp;&nbsp;1</span>*/}
                                        </Link>
                                    </li>
                                    <li className="cat-item">
                                        <Link to="/PersonalLoanAds/6">
                                            เงินกู้พิเศษเพื่อการเคหสงเคราะห์{/*<span>&nbsp;&nbsp;6</span>*/}
                                        </Link>
                                    </li>
                                </ul>
                            </aside>
    
                            <aside className="widget-post">
                                <h2 className="widget-title">เข้าชมมากที่สุด</h2>
                                {recentNews.map((news) => (
                                    <div key={news.id} className="item-recent clearfix">
                                        <img 
                                            src={`${IMGPATHS}img/Loan/${news.img}`} 
                                            alt={news.topic} 
                                            style={{ width: "70px" }} 
                                        />
                                        <h6 className="title">
                                            <Link 
                                                to={`/PersonalLoanDetail/${news.id}`}
                                                style={{fontSize:'16px'}}
                                                onClick={() => countNews(news.id)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {news.topic}
                                            </Link>
                                        </h6>
                                        <div className="date-recent">เข้าชม {news.readtime} ครั้ง</div>
                                        <br/>
                                    </div>
                                ))}
                            </aside>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Personalloanads;